export var UNINITIALIZED_API_PROP = "\nTried to access uninitialized DashboardAPI property.\n";
export var UNINITIALIZED_API = "\nTried to access uninitialized DashboardAPI.\n";
export var DashboardAPI = new Proxy({}, {
    get: function (_target, prop) {
        if (!window.DashboardAPI) {
            throw Error(UNINITIALIZED_API);
        }
        var value = window.DashboardAPI[prop];
        if (!value) {
            throw Error(UNINITIALIZED_API_PROP);
        }
        return value;
    },
});
